import React from "react";
import styles from "./Hyperlink.module.css";
import { joinClassNames } from "../../utils/joinClassNames";

export type HyperlinkProps = {
    children: React.ReactNode;
    className?: string;
    href: string;
    isExternalLink?: string;
    iconPath?: React.ReactElement<SVGElement>;
};

export const Hyperlink = ({
    children,
    className,
    href,
    isExternalLink,
    iconPath,
}: HyperlinkProps) => {
    const cssClasses = joinClassNames([styles.link, className ?? ""]);
    const showLink =
        href.trim() &&
        ((typeof children === "string" && children.trim()) || children);
    return showLink ? (
        <a href={href.trim()} className={cssClasses}>
            {children}
            {isExternalLink && iconPath}
        </a>
    ) : null;
};

export default Hyperlink;
